"use client";
import { createContext, useContext, useState } from "react";
import { BASE_URL } from "../config/config";

const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user") || "{}"); // must contain id

  /* ================= FETCH PROFILE ================= */
  const fetchProfile = async () => {
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user") || "{}");
        if (!user?.id) return null;

        try {
            setLoading(true);
            const res = await fetch(`${BASE_URL}/profile/${user.id}`, {
                headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
            });
            const data = await res.json();
            if (res.ok && data.status === 200) {
                setProfile(data.data);
                return data.data;
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };


  /* ================= UPDATE PROFILE ================= */
  const updateProfile = async ({ name, phone, imageFile }) => {
    if (!user?.id) {
      console.error("User ID missing");
      return false;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("name", name);
      formData.append("phone", phone);

      if (imageFile) {
        formData.append("image", imageFile);
      }

      const res = await fetch(
        `${BASE_URL}/profile/update/${user.id}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      const data = await res.json();

      if (res.ok && data.status === 200) {
        await fetchProfile(); // refresh profile
        return true;
      } else {
        console.error("Update failed:", data);
      }
    } catch (err) {
      console.error("Update profile error:", err);
    } finally {
      setLoading(false);
    }

    return false;
  };

  /* ================= UPDATE PASSWORD ================= */
  const updatePassword = async ({ currentPassword, newPassword }) => {
    try {
      setLoading(true);

      const res = await fetch(`${BASE_URL}/update-password/${user.id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          current_password: currentPassword,
          new_password: newPassword,
        }),
      });

      const data = await res.json();

      if (res.ok && data.status === 200) {
        return { success: true, message: data.message };
      } else {
        return { success: false, message: data.message || "Password update failed" };
      }
    } catch (err) {
      console.error("Update password error:", err);
      return { success: false, message: "Something went wrong" };
    } finally {
      setLoading(false);
    }
  };

  return (
    <ProfileContext.Provider
      value={{ profile, fetchProfile, updateProfile, updatePassword, loading }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfile = () => useContext(ProfileContext);
